<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">班组人员：</span>
        </div>
        <div style="display: flex;justify-content: flex-start;align-items: flex-start;flex-direction: column;">
          <div v-for="(item, index) in formData.patrolTeamPersonManageList" :key="index" style="margin-bottom: 10px;">
            <el-select v-model="item.personCode" filterable remote reserve-keyword
                       size="small" style="width: 280px"
                       :remote-method="remoteMethod"
                       placeholder="请输入关键词查询">
              <el-option v-for="item in personList" :key="item.code"
                         :label="item.name" :value="item.code">
              </el-option>
            </el-select>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removePatrolTeamPersonItem(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addPatrolTeamPersonItem(index)" v-if="index === formData.patrolTeamPersonManageList.length - 1"></i>
          </div>
        </div>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../api/KeepWatch'
  import {nError, nSuccess} from '../../../utils/notice'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'team-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧巡更',
          name: 'patrol-point-manage'
        }, {
          value: '班组管理'
        }],
        mainTitle: '添加班组',
        subheading: '',

        personList: [],

        formData: {
          name: '',
          patrolTeamPersonManageList: [
            {
              personCode: '',
              personName: '',
            }
          ],
        },

      }
    },
    created () {
      this.remoteMethod()
    },
    methods: {
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      // 获取人员列表
      getResponsiblePersonList (searchKey) {
        this.$axios.post(api.getResponsiblePersonList, {
          searchKey: searchKey || ''
        })
          .then(res => {
            if (res.data.retCode === 1) {
              this.personList = res.data.data
            }
          })
          .catch(errorHandler('获取人员列表失败'))
      },

      // 增加班组人员
      addPatrolTeamPersonItem (index) {
        if (!this.formData.patrolTeamPersonManageList[index].personCode) {
          nError('请先选择当前班组人员')
          return false
        }
        let obj = {
          personCode: '',
          personName: '',
        }
        this.formData.patrolTeamPersonManageList.push(obj)
      },

      // 删减班组人员
      removePatrolTeamPersonItem (index) {
        this.formData.patrolTeamPersonManageList.splice(index, 1)
      },

      toManagePage () {
        this.$router.push({
          name: 'team-manage'
        })
      },

      confirm () {
        if (!this.formData.name) {
          nError('请输入班组名称')
          return false
        }
        this.formData.patrolTeamPersonManageList.map(v => {
          this.personList.map(person => {
            if (v.personCode === person.code) {
              v.personName = person.name
            }
          })
        })
        this.$axios.post(api.addPatrolTeam, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/KeepWatch/TeamManage/TeamAdd.vue